import { lang, commonLang } from '@umu/ukit-lang';
import './departmentSelectDialogWithUSE.scss';
import { $window } from '@umu/umu-dom';
import React, { useReducer, useRef, useState } from 'react';
import { Button, ButtonType } from '@umu/umu-design';
import DListView from './components/list/list';
import { DialogReducer } from './DialogReducer';
import { DialogContext, initState } from './DialogContext';
import {
    DEPARTMENT_ACCESS,
    DefaultSelectDepartmentItem,
    DefaultSelectDepartmentMemberItem,
    IDListRef,
    SectionType,
    TravelType,
} from './type';
import { enableMapSet } from 'immer';
import { If } from 'common/src/components';
import { cleanSelectedState } from './DialogContextSet';

interface IProps {
    useId: string; // USE Id 必须传
    title: string; // 对话框title
    desc?: string; // 对话框描述
    btnConfirmText?: string; // 确认按钮文案
    btnConfirmType?: ButtonType; // 确认按钮类型-与Button 类型
    departmentId: string; // 默认展示的部门id
    travelType: TravelType; // 对话框类型，
    isRadio?: boolean; // 是否单选模式
    expendParams?: {
        [propName: string]: string;
    }; // 接口额外扩展参数
    excludeDepartmentIds?: string; // 排除的id 用,隔开
    source?: string; // 对学习负责人特殊处理
    isAllowSelect?: boolean; // 是否允许支持全选
    checkableRoot?: boolean; // 是否开放选择根部门
    allSelectText?: string; // 全选展示文案
    isShowMember?: boolean; // 是否展示成员
    limit?: number; // 多选个数限制
    access?: DEPARTMENT_ACCESS;
    cbClose?: () => void;
    isRequiredSelect?: boolean; // 是否必须选择
    cbDo?: (data: any[]) => void; // 已选回调。
    isOnlyShowRightList?: boolean;
    isCanSelectParentDepartment?: boolean; // 是否可以选择父部门
    isCanClickOriginStructure?: boolean; // 是否可以点击组织架构
    isOnlyShowUSESelectedDepartment?: boolean; // 是否只加载 USE 已选中的部门
    defaultSelectedDepartmentList?: DefaultSelectDepartmentItem[];
    defaultSelectedMemberList?: DefaultSelectDepartmentMemberItem[];
}

enableMapSet();

export function DepartmentSelectDialogWithUSE(props: IProps) {
    const {
        desc,
        useId,
        btnConfirmText,
        isShowMember = true,
        isRequiredSelect = false,
        isOnlyShowRightList = false,
        isCanSelectParentDepartment = false,
        isOnlyShowUSESelectedDepartment = false,
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [state, dispatch] = useReducer(DialogReducer, { ...initState });

    const refList = useRef<IDListRef>(null);
    const onConfirm = () => {
        if (!props.cbDo) {
            return;
        }

        const funCb = props.cbDo;

        $window.setTimeout(() => {
            funCb(state.selectedList);
        }, 100);
    };
    const onClose = () => {
        if (refList && refList.current) {
            refList.current.cleanStateByParent();
        }
        if (props.cbClose) {
            const funCb = props.cbClose;
            $window.setTimeout(() => {
                funCb();
            }, 100);
        }
    };

    const removeAll = () => {
        cleanSelectedState({
            state,
            dispatch,
        });
    };

    const render = () => {
        const title = props.title;
        const btnConfirmType = props.btnConfirmType || 'primary';
        const subTitleLeft = lang('待选');
        const subTitleRight = lang('已选');
        return (
            <DialogContext.Provider
                value={{
                    state,
                    dispatch,
                }}
            >
                <div className="department-select-dialog department-select-dialog-with-use" title="">
                    <div className="content-head">
                        <div className="content-head-title">{title}</div>
                    </div>
                    <If condition={!!desc}>
                        <div className="content-desc">{desc}</div>
                    </If>
                    <div className="content-body">
                        <div className={`left ${isOnlyShowRightList ? 'hidden-left' : ''}`}>
                            <span className="subtitle">{subTitleLeft}</span>
                            <div className="subcontent">
                                <DListView
                                    useId={useId}
                                    btnType={btnConfirmType}
                                    access={props.access}
                                    type={props.travelType}
                                    section={SectionType.left}
                                    departmentId={props.departmentId}
                                    isRadio={props.isRadio}
                                    expendParams={props.expendParams}
                                    ref={refList}
                                    isCanClickOriginStructure={props.isCanClickOriginStructure}
                                    defaultSelectedDepartmentList={props.defaultSelectedDepartmentList}
                                    defaultSelectedMemberList={props.defaultSelectedMemberList}
                                    excludeDepartmentIds={props.excludeDepartmentIds}
                                    isAllowSelect={props.isAllowSelect}
                                    isShowMember={isShowMember}
                                    allSelectText={props.allSelectText}
                                    limit={props.limit}
                                    clsName="left"
                                    isLoading={isLoading}
                                    setIsLoading={setIsLoading}
                                    isOnlyShowRightList={isOnlyShowRightList}
                                    isCanSelectParentDepartment={isCanSelectParentDepartment}
                                    isOnlyShowUSESelectedDepartment={isOnlyShowUSESelectedDepartment}
                                />
                            </div>
                        </div>

                        <div className={`right ${isOnlyShowRightList ? 'right-all' : ''}`}>
                            <div className="suttitle-container">
                                <span className="subtitle">{subTitleRight}</span>
                                {isOnlyShowRightList && (
                                    <Button type="ghost-blue" onClick={removeAll}>
                                        {lang('全部移除')}
                                    </Button>
                                )}
                            </div>

                            <div className="subcontent">
                                <DListView
                                    useId={useId}
                                    access={props.access}
                                    type={props.travelType}
                                    section={SectionType.right}
                                    departmentId={props.departmentId}
                                    isRadio={props.isRadio}
                                    clsName="right"
                                    isOnlyShowRightList={isOnlyShowRightList}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="dialog-content-footer">
                        <Button
                            disabled={isLoading || (isRequiredSelect && state.selectedList.length === 0)}
                            className="dialog-footer-btn"
                            type={btnConfirmType}
                            onClick={onConfirm}
                        >
                            {btnConfirmText ?? commonLang('确定')}
                        </Button>
                        <Button className="dialog-footer-btn" type="ghost-grey" onClick={onClose}>
                            {commonLang('取消')}
                        </Button>
                    </div>
                </div>
            </DialogContext.Provider>
        );
    };
    return render();
}
